import { GA_GENERAL_CATEGORY, GA_GENERAL_EVENTS, GA_GENERAL_POPUPS_SOURCES } from 'modules/ga/generalEvents';
import { closePopups, openPopup } from 'modules/popup/actions';
import { selectIsAnyPopupShown } from 'modules/popup/popup.selectors';
import app from 'new-ui/app';
import { POPUP, POPUPS } from 'utils/constants/popup';

export const answerQuestionAction = ({
  question, answer, toastText, redirectPopup,
}) => async (dispatch) => {
  await app.answerQuestion({ [question]: answer });

  if (toastText) {
    app.alert({ content: toastText });
  }
  if (redirectPopup && POPUPS.includes(redirectPopup)) {
    dispatch(openPopup({ type: redirectPopup }));
  }
};

export const showUrlPopupAction = ({ type, data }) => (dispatch, getState) => {
  const isAnyPopupShown = selectIsAnyPopupShown(getState());
  if (isAnyPopupShown) {
    return;
  }
  window.Intercom('hide');

  const { source } = data;
  app.sendGoogleAnalyticsEvent(
    GA_GENERAL_CATEGORY,
    GA_GENERAL_EVENTS.POPUP_OPEN,
    { popup: type, source: GA_GENERAL_POPUPS_SOURCES.URL, data: source },
  );

  dispatch(openPopup({ type, data }));
};

export const questionToAskAction = ({ question }) => (dispatch) => {
  app.editQuestion([question], async ({ notFound }) => {
    if (notFound) {
      // should be invariant
      console.error(`${question} question is not found`);
      dispatch(closePopups());
      return;
    }

    dispatch(openPopup({
      type: POPUP.MEDICAL_PROFILE,
      data: {
        highlight: question,
        scrollTop: 0,
      },
    }));

    await app.requestRematch();
  });
};

export const questionsToAskAction = ({ questions }) => (dispatch) => {
  dispatch(openPopup({
    type: POPUP.QUESTIONS,
    data: { questions },
  }));
};

export const unsubscribeFormAction = () => (dispatch) => {
  dispatch(openPopup({ type: POPUP.UNSUBSCRIBE_FORM }));
};
